export default "__VITE_ASSET__CKjTW56u__"